// services/quotationService.js

const API_BASE_URL = 'http://staging.maamaas.com:8080/protohub/api';

// Helper function for handling API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

// Quotation Service
export const quotationService = {
  // Get all quotations for a vendor
  getVendorQuotations: async (vendorId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/vendor/quotations/all`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error('Error fetching vendor quotations:', error);
      return [];
    }
  },

  // Get all quotations
  getAllQuotations: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/vendor/quotations/all`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error('Error fetching all quotations:', error);
      return [];
    }
  },

  // Get quotation by ID
  getQuotationById: async (quotationId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/vendor/quotations/${quotationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error fetching quotation ${quotationId}:`, error);
      throw error;
    }
  },

  // Get quotations by enquiry ID
  getQuotationsByEnquiryId: async (enquiryId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/vendor/quotations/enquiry/${enquiryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await handleResponse(response);
    } catch (error) {
      console.error(`Error fetching quotations for enquiry ${enquiryId}:`, error);
      return null;
    }
  },

  // Send quotation with multipart form data (ONLY multipart - no JSON fallback)
 sendQuotation: async (quotationData, documentFile = null) => {
  try {

    const formData = new FormData();

    // JSON object required by backend
    const quotation = {
      enquiryId: quotationData.enquiryId,
      vendorId: quotationData.vendorId,
      quotationAmount: quotationData.quotationAmount,
      estimatedDeliveryDays: quotationData.estimatedDeliveryDays,
      validUntil: quotationData.validUntil,
      message: quotationData.message,
      quotationDocument: documentFile ? documentFile.name : ""
    };

    formData.append(
      "quotation",
      new Blob(
        [JSON.stringify(quotation)],
        {
          type: "application/json"
        }
      )
    );

    if (documentFile) {
      formData.append("document", documentFile);
    }

    console.log("========= FormData =========");

    for (const pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await fetch(
      `${API_BASE_URL}/vendor/quotations/send`,
      {
        method: "POST",
        body: formData
      }
    );

    if (!response.ok) {

      const text = await response.text();

      throw new Error(text || "Failed to send quotation");

    }

    return await response.json();

  } catch (error) {

    console.error(error);

    throw error;

  }
},
};

export default quotationService;